import {IRestrictionsStrategy} from "./restrictions.strategy.interface";
import {RestrictionsCollection} from "../restrictions-collection";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IRawRestrictionType} from "../raw-restriction-types.interface";
import {computeRestrictionsExpirationDate} from "./compute-restrictions-expiration-date";
import {makeObservable, observable, runInAction} from "mobx";
import {RestrictionsController_GetAnonymousRestrictionsRequest} from "../../api/api.service";

export class AnonymousUserRestrictionsStrategy implements IRestrictionsStrategy {
    constructor(private readonly services: IServiceFactoryExtended) {
        const restrictionsFromConfig = this._getRestrictionsFromConfig();
        if(restrictionsFromConfig) {
            computeRestrictionsExpirationDate(restrictionsFromConfig);
            this.restrictions = new RestrictionsCollection(restrictionsFromConfig, this.services);
        } else {
            this.restrictions = new RestrictionsCollection([], this.services);
            this._updateRestrictionsFromServer();
        }

        makeObservable(this);
    }

    @observable.ref
    restrictions: RestrictionsCollection;

    private async _updateRestrictionsFromServer(): Promise<void> {
        const request: RestrictionsController_GetAnonymousRestrictionsRequest = {
            BrandId: this.services.sdk.getBrandID(),
            SubBrandId: this.services.sdk.getSubBrandID(),
            ClientVersion: this.services.sdk.getSkin().getVersion(),
            ProductPackage: this.services.sdk.getProductPackageId(),
            FakeClientIP: this.services.sdk.getFakeClientIP()
        }

        const response = await this.services.api.restrictionsController.getAnonymousRestrictions(request);
        const restrictionsByAction: IRawRestrictionType[] = response.RestrictionsByAction.map(rba => {
            return {
                ActionId: rba.ActionId,
                ActionName: rba.ActionName,
                Entities: rba.Entities.map(entity => {
                    return {
                        EntityId: entity.EntityId,
                        EntityName: entity.EntityName,
                        Values: entity.Values.map(value => {
                            return {
                                Value: value.Value,
                                ExpirationDate: value.ExpirationDate,
                                ReasonId: value.ReasonId,
                                SecondsToExpire: value.SecondsToExpire,
                            }
                        })
                    }
                })
            }
        })
        computeRestrictionsExpirationDate(restrictionsByAction);
        runInAction(() => {
            this.restrictions = new RestrictionsCollection(restrictionsByAction, this.services);
        });
    }

    private _getRestrictionsFromConfig(): IRawRestrictionType[] | null {
        const restrictionsConfig = this.services.configuration.servicesConfigs.Restrictions as any;
        if(restrictionsConfig?.anonymousRestrictions?.RestrictionsByAction) {
            return restrictionsConfig.anonymousRestrictions.RestrictionsByAction as IRawRestrictionType[];
        }
        return null;
    }

}